/**
 * In-memory session state. We persist the player's index locally so that a
 * reload after network hiccup doesn't lose where they are; the authoritative
 * state is on the server.
 */
export interface LocalState {
  index: number;
  lang: string;
  queuedChoice?: { scenarioIndex: number; choice: string; timeToDecideMs: number };
}

const KEY = 'allot.state';

export function loadState(): LocalState | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as LocalState;
  } catch {
    return null;
  }
}

export function saveState(state: LocalState): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* ignore quota errors */
  }
}

export function clearState(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
